import React from 'react';
import PropTypes from 'prop-types';
import { Sparkles } from 'lucide-react';

// Avatar de Muse, le modèle local du Mac mini. `thinking` le fait pulser pendant le raisonnement.
const MuseAvatar = ({ thinking = false }) => (
  <div
    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-teal-500 to-cyan-600 text-white shadow-sm ${
      thinking ? 'animate-pulse' : ''
    }`}
  >
    <Sparkles className="h-4 w-4" />
  </div>
);

MuseAvatar.propTypes = {
  thinking: PropTypes.bool,
};

export default MuseAvatar;
